import { useEffect, useState } from "react";

/**
 * `window.matchMedia(query).matches`, acompanhando mudanças.
 *
 * Sem `matchMedia` (jsdom, SSR) devolve `fallback`: para "é desktop" o fallback é
 * `true`, para "prefere menos movimento" é `false`.
 *
 * @param {string} query
 * @param {boolean} [fallback]
 */
export function useMediaMatch(query, fallback = false) {
  const supported = typeof window !== "undefined" && typeof window.matchMedia === "function";
  const [matches, setMatches] = useState(() => (supported ? window.matchMedia(query).matches : fallback));

  useEffect(() => {
    if (!supported) return undefined;
    const list = window.matchMedia(query);
    const sync = () => setMatches(list.matches);
    sync();
    list.addEventListener?.("change", sync);
    return () => list.removeEventListener?.("change", sync);
  }, [query, supported]);

  return matches;
}

/** Mesmo corte do `md` do Tailwind: abaixo dele o menu lateral some e o cartão vira rodapé. */
export const useIsDesktop = () => useMediaMatch("(min-width: 768px)", true);

export const usePrefersReducedMotion = () => useMediaMatch("(prefers-reduced-motion: reduce)", false);
